export default __webpack_public_path__ + "static/media/filter6.31dbcbbe.svg";